import React from 'react';
import { CalendarDays, Home, UserRound } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const navItems = [
  { to: '/dashboard', icon: Home, label: 'Dashboard' },
  { to: '/book', icon: CalendarDays, label: 'Bookings' },
  { to: '/profile', icon: UserRound, label: 'Account' },
];

export default function BottomNav() {
  return (
    <footer className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#141414] pb-[env(safe-area-inset-bottom,0px)]">
      <nav className="mx-auto h-14 max-w-xl px-8 flex items-center justify-between" aria-label="Primary">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `inline-flex h-10 w-10 items-center justify-center transition ${
                isActive ? 'text-[#c00000]' : 'text-white'
              }`
            }
            aria-label={item.label}
          >
            <item.icon size={22} />
          </NavLink>
        ))}
      </nav>
    </footer>
  );
}
